import { render, staticRenderFns } from "./SavedFilesModal.vue?vue&type=template&id=18a54748&scoped=true"
import script from "./SavedFilesModal.vue?vue&type=script&lang=js"
export * from "./SavedFilesModal.vue?vue&type=script&lang=js"
import style0 from "./SavedFilesModal.vue?vue&type=style&index=0&id=18a54748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a54748",
  null
  
)

export default component.exports